(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 7107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 25,
    width: 25,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12c1.292 4.338 5.31 7.5 10.066 7.5.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgEye);

/***/ }),

/***/ 8657:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration",
      function () {
        return __webpack_require__(1814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ avatarUpload_AvatarUpload; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./src/components/ui/loader/Loader.tsx
var Loader = __webpack_require__(574);
// EXTERNAL MODULE: ./src/services/upload/uploadService.ts
var uploadService = __webpack_require__(6447);
// EXTERNAL MODULE: ./src/hooks/redux.ts
var redux = __webpack_require__(5096);
;// CONCATENATED MODULE: ./public/static/images/default-avatar.png
/* harmony default export */ var default_avatar = ({"src":"/_next/static/media/default-avatar.68a99070.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEXDw8P+/v7Gxsbl5eXw8PDZ2dmJR6BtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVQImR2LQQ4AMAyCwK7///JiL2IMQoBGyG4KRufK03dldU/q0sdoJVJqPg3jAGPbPwT8AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/static/svg/close.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 27,
    width: 27,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 18 18 6M6 6l12 12"
  })));
};

/* harmony default export */ var svg_close = (SvgClose);
;// CONCATENATED MODULE: ./public/static/svg/edit.svg
var edit_path;

function edit_extends() { edit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return edit_extends.apply(this, arguments); }



var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/react.createElement("svg", edit_extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    width: 18,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), edit_path || (edit_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.232 5.232 3.536 3.536m-2.036-5.036a2.5 2.5 0 1 1 3.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  })));
};

/* harmony default export */ var edit = (SvgEdit);
;// CONCATENATED MODULE: ./src/components/common/avatarUpload/AvatarUpload.tsx


/* eslint-disable react-hooks/exhaustive-deps */ 








var AvatarUpload = function(param) {
    var avatarUrl = param.avatarUrl, onAvatarUpload = param.onAvatarUpload, public_id = param.public_id, onAvatarDelete = param.onAvatarDelete;
    var isAvatarUpdating = (0,redux/* useAppSelector */.C)(function(state) {
        return state.auth.isAvatarUpdating;
    });
    var ref = (0,react.useState)(null), file = ref[0], setFile = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,uploadService/* useUploadFileMutation */.Yh)(), 2), uploadFile = ref1[0], ref2 = ref1[1], isUploading = ref2.isLoading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,uploadService/* useDeleteFileMutation */.g3)(), 2), deleteFile = ref3[0], ref4 = ref3[1], isDeleting = ref4.isLoading;
    (0,react.useEffect)(function() {
        if (file) {
            var formData = new FormData();
            formData.append("image", file);
            uploadFile(formData).unwrap().then(function(uploadedFile) {
                return onAvatarUpload(uploadedFile);
            }).catch(function(error) {
                return react_toastify_esm.toast.error(error.data.message);
            });
        }
    }, [
        file
    ]);
    var handleChange = function(e) {
        if (e.target.files) setFile(e.target.files[0]);
    };
    var handleDelete = function(e) {
        e.stopPropagation();
        deleteFile(public_id).unwrap().then(function(data) {
            if (data.message === "success") {
                onAvatarDelete();
            } else if (data.message) {
                react_toastify_esm.toast.info(data.message);
            }
        }).catch(function(error) {
            return react_toastify_esm.toast.error(error.data.message);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inline-block relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "rounded-full",
                        width: 70,
                        height: 70,
                        objectFit: "cover",
                        src: avatarUrl || default_avatar,
                        alt: "Avatar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        onChange: handleChange,
                        className: "sr-only",
                        multiple: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-[27px] h-[27px] flex justify-center items-center rounded-full bg-slate-500 absolute bottom-0 right-0 hover:bg-slate-600 transition-colors",
                        children: isUploading || isDeleting || isAvatarUpdating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                            size: "17"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(edit, {})
                    })
                ]
            }),
            public_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "absolute -top-4 -right-4 hover:scale-125 transition-transform will-change-transform",
                onClick: handleDelete,
                type: "button",
                "aria-label": "Delete avatar",
                disabled: isUploading || isDeleting || isAvatarUpdating,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_close, {
                    className: "stroke-red-500"
                })
            })
        ]
    });
};
/* harmony default export */ var avatarUpload_AvatarUpload = (AvatarUpload);


/***/ }),

/***/ 5275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);
/* harmony import */ var _Input_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8622);
/* harmony import */ var _Input_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Input_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Input = function(param) {
    var _type = param.type, type = _type === void 0 ? "text" : _type, name = param.name, value = param.value, onChange = param.onChange, placeholder = param.placeholder, containerClass = param.containerClass, inputClass = param.inputClass, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? 50 : _maxLength, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__.clsx)((_Input_module_scss__WEBPACK_IMPORTED_MODULE_2___default().input_container), containerClass),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__.clsx)("rounded-md bg-gray-700 border-none p-3 placeholder:text-primaryLightColor placeholder:opacity-50 w-full  outline-none", inputClass),
                type: type,
                name: name,
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                maxLength: maxLength
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _configs_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5155);


var Loader = function(param) {
    var _size = param.size, size = _size === void 0 ? "30" : _size, _color = param.color, color = _color === void 0 ? _configs_constants__WEBPACK_IMPORTED_MODULE_1__/* .colorLightPrimary */ .VK : _color, _duration = param.duration, duration = _duration === void 0 ? "1s" : _duration, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "20 37 55 30",
        enableBackground: "new 0 0 0 0",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: color,
            d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                dur: duration,
                from: "0 50 50",
                to: "360 50 50",
                repeatCount: "indefinite"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);


var PageTitle = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__.clsx)("text-2xl xl:text-4xl font-bold mb-5 md:mb-8", className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 1814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ registration; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/providers/meta/Meta.tsx
var Meta = __webpack_require__(8222);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./src/components/common/avatarUpload/AvatarUpload.tsx + 3 modules
var AvatarUpload = __webpack_require__(3609);
// EXTERNAL MODULE: ./src/components/ui/input/Input.tsx
var Input = __webpack_require__(5275);
// EXTERNAL MODULE: ./src/components/ui/loader/Loader.tsx
var Loader = __webpack_require__(574);
// EXTERNAL MODULE: ./src/components/ui/pageTitle/PageTitle.tsx
var PageTitle = __webpack_require__(1269);
// EXTERNAL MODULE: ./src/redux/auth/authActions.ts + 1 modules
var authActions = __webpack_require__(6971);
// EXTERNAL MODULE: ./src/redux/auth/authSlice.ts
var authSlice = __webpack_require__(4269);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(3293);
// EXTERNAL MODULE: ./src/hooks/redux.ts
var redux = __webpack_require__(5096);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(8470);
// EXTERNAL MODULE: ./public/static/svg/eye.svg
var eye = __webpack_require__(7107);
;// CONCATENATED MODULE: ./src/components/screens/registration/Registration.tsx
















var Registration = function() {
    var ref, ref1;
    (0,useAuth/* useAuthRedirect */.l)();
    var ref2 = (0,react.useState)({
        username: "",
        email: "",
        password: "",
        passwordRepeat: "",
        avatar: null
    }), formData = ref2[0], setFormData = ref2[1];
    var ref3 = (0,react.useState)("password"), passwordInputType = ref3[0], setPasswordInputType = ref3[1];
    var dispatch = (0,redux/* useAppDispatch */.T)();
    var isLoading = (0,redux/* useAppSelector */.C)(function(state) {
        return state.auth.isLoading;
    });
    var isError = (0,redux/* useAppSelector */.C)(function(state) {
        return state.auth.isError;
    });
    var message = (0,redux/* useAppSelector */.C)(function(state) {
        return state.auth.message;
    });
    (0,react.useEffect)(function() {
        if (isError && message) {
            react_toastify_esm.toast.error(message);
        }
    }, [
        isError,
        message
    ]);
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,authSlice/* resetAuth */.Li)());
            setFormData({
                username: "",
                email: "",
                password: "",
                passwordRepeat: "",
                avatar: null
            });
        };
    }, [
        dispatch
    ]);
    var onAvatarUpload = function(avatar) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            avatar: avatar
        }));
    };
    var onAvatarDelete = function() {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            avatar: null
        }));
    };
    var togglePasswordInputType = function(e) {
        e.stopPropagation();
        passwordInputType === "password" ? setPasswordInputType("text") : setPasswordInputType("password");
    };
    var validateSubmit = function() {
        var username = formData.username, email = formData.email, password = formData.password, passwordRepeat = formData.passwordRepeat;
        if (!username || !email || !password || !passwordRepeat) {
            react_toastify_esm.toast.error("Please fill in all fields");
            return false;
        }
        if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            react_toastify_esm.toast.error("Please enter a valid email address");
            return false;
        }
        if (password.length < 5) {
            react_toastify_esm.toast.error("Min length of password is 5 characters");
            return false;
        }
        if (password !== passwordRepeat) {
            react_toastify_esm.toast.error("Passwords do not match");
            return false;
        }
        return true;
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        if (validateSubmit()) dispatch((0,authActions/* register */.z2)(formData));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "container flex flex-col justify-center content-center h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                className: "text-center",
                children: "Register your account"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "max-w-md w-full mx-auto mb-8",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarUpload/* default */.Z, {
                            avatarUrl: (ref = formData.avatar) === null || ref === void 0 ? void 0 : ref.url,
                            onAvatarDelete: onAvatarDelete,
                            onAvatarUpload: onAvatarUpload,
                            public_id: ((ref1 = formData.avatar) === null || ref1 === void 0 ? void 0 : ref1.public_id) || ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        name: "username",
                        value: formData.username,
                        onChange: function(e) {
                            return (0,utils/* handleInputChange */.jC)(e, setFormData);
                        },
                        placeholder: "Username"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        name: "email",
                        value: formData.email,
                        onChange: function(e) {
                            return (0,utils/* handleInputChange */.jC)(e, setFormData);
                        },
                        placeholder: "Email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        name: "password",
                        value: formData.password,
                        onChange: function(e) {
                            return (0,utils/* handleInputChange */.jC)(e, setFormData);
                        },
                        placeholder: "Password",
                        type: passwordInputType,
                        containerClass: "relative",
                        inputClass: "pr-11",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "absolute top-[50%] translate-y-[-50%] right-3 leading-none transition-transform will-change-transform hover:scale-110",
                            onClick: togglePasswordInputType,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eye/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        name: "passwordRepeat",
                        value: formData.passwordRepeat,
                        onChange: function(e) {
                            return (0,utils/* handleInputChange */.jC)(e, setFormData);
                        },
                        placeholder: "Repeat password",
                        type: passwordInputType,
                        containerClass: "relative",
                        inputClass: "pr-11",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "absolute top-[50%] translate-y-[-50%] right-3 leading-none transition-transform will-change-transform hover:scale-110",
                            onClick: togglePasswordInputType,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eye/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "btn w-full mt-8 relative",
                        children: [
                            "Register",
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                                className: "absolute right-2 top-[50%] translate-y-[-50%]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-center text-sm",
                children: [
                    "Already have an account?",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/login",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "ml-1 underline underline-offset-2 hover:no-underline text-secondaryColor",
                            children: "Log in"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var registration_Registration = (Registration);

;// CONCATENATED MODULE: ./src/pages/registration.tsx



var RegistrationPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
        title: "Registration",
        description: "Registration page",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(registration_Registration, {})
    });
};
/* harmony default export */ var registration = (RegistrationPage);


/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3293);




var Meta = function(param) {
    var title = param.title, description = param.description, _image = param.image, image = _image === void 0 ? null : _image, children = param.children;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().asPath;
    var currentUrl = "".concat("https://crypto-pet-front-88oi.vercel.app").concat(asPath);
    var siteName = "Crypto notebook";
    var ogLogo = "".concat("https://crypto-pet-front-88oi.vercel.app", "/static/images/og-logo.jpg");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        itemProp: "headline",
                        children: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        itemProp: "description",
                        name: "description",
                        content: (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .onlyText */ .RJ)(description, 152)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: currentUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: currentUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image || ogLogo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: siteName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .onlyText */ .RJ)(description, 197)
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            children
        ]
    });
};


/***/ }),

/***/ 8622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input_container":"Input_input_container__zlyAD"};

/***/ }),

/***/ 603:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArray(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [678,774,888,179], function() { return __webpack_exec__(8657); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);